import React from "react";

import Background from "../../../assets/market/market-02-select.png";
import ImageA from "../../../assets/market/market-02-option-a.png";
import ImageB from "../../../assets/market/market-02-option-b.png";

import GameSelectionLayout from "../GameSelectionLayout";

const MarketPage5 = ({ setCurrentPage, setGarbageQtty }) => {
  const handleClickA = () => {
    setCurrentPage("market-6");
  };

  const handleClickB = () => {
    setGarbageQtty((prev) => prev + 10);
    setCurrentPage("market-7");
  };

  return (
    <GameSelectionLayout
      bg={Background}
      imageA={ImageA}
      textA="리필스테이션"
      onClickA={handleClickA}
      imageB={ImageB}
      textB="인터넷주문"
      onClickB={handleClickB}
      currentIndex={5}
    >
      그러고 보니 샴푸랑 세제도 떨어졌네.
      <br />
      버스 타고 갈 수 있는 거리에
      <br />
      리필스테이션을 갈까?
      <br />
      아니면 무거우니까 인터넷 주문?
    </GameSelectionLayout>
  );
};

export default MarketPage5;
